import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[axisDecimal]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: AxisDecimalValidatorDirective,
      multi: true
    }
  ]
})
export class AxisDecimalValidatorDirective implements Validator {
  validate(control: AbstractControl): { [key: string]: any } {
    const Regex =  /^(\d*|\d+\.\d{1,3}|\d*\.\d{1,30})$/;
     return Regex.test(control.value) ? null :
    {
        axisNumerics: {
          valid: false
        }
    };
  }
}
